<template>
	<el-row class="mainThreebox">
		<!-- 标题 -->
		<el-row class="mainOnebox_title">
			<img src="@/assets/image/home/title_news.png">
		</el-row>
		<!-- 内容 -->
		<el-row class="mainOnebox_main">
			<el-row class="mainOnebox_main_list">
				<img src="@/assets/image/home/newspic1.png">
				<el-row>
					<el-row class="mainOnebox_main_list_name1">2017 FICON Sao PauloInternation Fair</el-row><br><br>
					<el-row class="mainOnebox_main_list_name2">Our team will bring and show you some fantastic design of
						tactile indicator in 2017 FICON Sao Paulo Internationl Fair on next Jan . welcome all of customers
						to visit ourbooth , and we can discuss cooperation there . Thankyou</el-row>
				</el-row>

			</el-row>
			<el-row class="mainOnebox_main_list">
				<img src="@/assets/image/home/newspic2.png">
				<el-row>
					<el-row class="mainOnebox_main_list_name1">16th.Xiamen Internation Stone Fair</el-row><br><br>
					<el-row class="mainOnebox_main_list_name2">Hangzhou Hezone Industry Tech Co., Ltd attended 16th. Xiamen International Stone Fair and have a great success. We thank you to visit our booth and interest in our products. Hope can get your E-mail or phone call and welcome you to visit our factory in Zhejiang.</el-row>
				</el-row>
			</el-row>
		</el-row>
	</el-row>
</template>

<script>
	// import banner from './components/banner.vue';

	export default {
		components: {
			// banner:banner,
		},
		data() {
			return {

			}
		},
		methods: {

		},

	}
</script>

<style lang="less" scoped>
	@vw: 19.2vw;

	.mainThreebox {
		background: url(../../../assets/image/home/home_bg1.jpg);

		.mainOnebox_title {
			width: 100%;
			text-align: center;

			img {
				margin-top: 5vw;
				margin-bottom: 4vw;
				width: 12.7%;
			}
		}

		.mainOnebox_main {
			max-width: 1530px;
			margin: 0 auto;
			height: auto;
			display: flex;
			justify-content: center;
			flex-direction: row;
			flex-wrap: wrap;
			.mainOnebox_main_list {
				max-width: 572px;
				height: auto;
				margin: 1vh 1.5vw;
				border-radius: 20px;
				overflow: hidden;
				display: flex;
				justify-content: flex-start;

				img {
					width: 160/@vw;
					height: 200/@vw;
					min-width: 80px;
					min-height: 100px;
					border-radius: 1vw;
				}

				.mainOnebox_main_list_name1 {
					font-weight: 700;
					max-width: 382px;
					padding-left: 30/@vw;
					color: #a08c6e;
					font-size: 32/@vw;
				}

				.mainOnebox_main_list_name2 {
					max-width: 382px;
					padding-left: 30/@vw;
					color: #1a1a1a;
					font-size: 16/@vw;
				}
			}

			.mainOnebox_main_list_none {
				max-width: 572px;
				height: 0;
			}
		}
	}
</style>
